import { Gift } from 'lucide-react'
import { useMemo } from 'react'

import { decodeHtml } from '../../../../Theme'
import { isPromoActive } from '../../../lib'
import { useProductAttributes } from '../../../state'

export function SpecialPromo() {
  const { productAttributes } = useProductAttributes()
  const giftContent = productAttributes?.special_text_promo

  const decodedGiftContent = useMemo(() => {
    return giftContent ? decodeHtml(giftContent) : null
  }, [giftContent])

  if (!giftContent || !decodedGiftContent) return null
  if (!isPromoActive(productAttributes?.text_from_date, productAttributes?.text_to_date)) return null

  return (
    <div className="flex flex-row justify-center md:justify-start xl:justify-start items-center bg-cards-bg mb-3 xl:mb-5">
      <Gift className="w-5 h-5 xl:w-9 xl:h-9 mr-5 text-custom-red" />
      <div
        className="font-main-font text-sm xl:text-xl flex justify-start text-custom-red"
        dangerouslySetInnerHTML={{ __html: decodedGiftContent }}
      />
    </div>
  )
}
